import { Modal } from "@circle-react-shared/uikit/ModalV2";

export const PostHeaderSkeleton = () => (
  <Modal.Header className="flex w-full items-center gap-4">
    <div className="bg-tertiary h-8 w-3/5 animate-pulse rounded-md" />
  </Modal.Header>
);
